import type { ReactNode } from 'react';

/**
 * Tabellen.
 *
 * Bewusst eine schlichte HTML-Tabelle statt einer Datengitter-Bibliothek: die
 * Listen in diesem Produkt sind Listen, keine Tabellenkalkulation. Der
 * gemeinsame Stil sorgt für gleiche Kopfzeilen, gleiche Zeilenhöhe und einen
 * ruhigen Hover-Zustand.
 */

export function Table({
  headers,
  children,
  label,
}: {
  headers: ReactNode[];
  children: ReactNode;
  label?: string;
}): JSX.Element {
  return (
    <div className="table-scroll">
      <table aria-label={label}>
        <thead>
          <tr>
            {headers.map((header, index) => (
              // Die Kopfzeile ist fest, deshalb genügt hier der Index.
              <th key={index} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

/**
 * Aktionsspalte einer Zeile.
 *
 * Aktionen stehen rechts und gruppiert, damit die Zeile nicht als Kette
 * blauer Links auseinanderfällt.
 */
export function RowActions({ children }: { children: ReactNode }): JSX.Element {
  return (
    <td className="zelle-aktionen">
      <div className="row-actions">{children}</div>
    </td>
  );
}
